import angular from 'angular';

// Json structure: {"type":"integer"} ("integer" or "float")

/**
 * Controla la tabla de inspecciones.
 */
CamposExtraNumberCtrl.$inject = [];
export default function CamposExtraNumberCtrl() {
    var campExtNum = this;
    campExtNum.hasError = false;

    campExtNum.jsonOptions = angular.fromJson(campExtNum.campoExtra.json);

    campExtNum.claseRow = issetAndNotEmpty(campExtNum.claseRow) ? campExtNum.claseRow == 'true' : true;

    campExtNum.campoExtra.valor = campExtNum.jsonOptions.type === "integer"
        ? parseInt(campExtNum.campoExtra.valor)
        : parseFloat(campExtNum.campoExtra.valor);

    campExtNum.isNaN = function (num) {
        return isNaN(num);
    };

    campExtNum.validate = function () {
        if (angular.isNumber(campExtNum.campoExtra.valor)) {

            campExtNum.campoExtra.valor = campExtNum.jsonOptions.type === "integer"
                ? parseInt(campExtNum.campoExtra.valor)
                : parseFloat(campExtNum.campoExtra.valor);

            campExtNum.hasError = false;
            campExtNum.campoExtra.changed = true;

        } else {
            campExtNum.hasError = true;
            campExtNum.campoExtra.changed = false;
        }
    };

    campExtNum.borrar = function () {
        campExtNum.campoExtra.valor = null;
        campExtNum.campoExtra.changed = true;
    };
}